import { type JSX, splitProps } from 'solid-js'

export type KbdTone = 'default' | 'onFill'

export interface KbdProps extends JSX.HTMLAttributes<HTMLElement> {
  tone?: KbdTone
}

const toneClasses: Record<KbdTone, string> = {
  default:
    'border-[var(--color-neutral-300)] bg-[var(--color-neutral-100)] text-[color:var(--color-text-muted)]',
  onFill:
    'border-[color:color-mix(in_srgb,currentColor_30%,transparent)] bg-[color:color-mix(in_srgb,currentColor_14%,transparent)] text-current',
}

export function Kbd(props: KbdProps) {
  const [local, rest] = splitProps(props, ['tone', 'class', 'children'])

  return (
    <kbd
      {...rest}
      class={`inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-[var(--radius-4)] border px-1 font-[family-name:var(--font-sans)] text-[length:var(--text-xs)] font-[var(--font-semibold)] leading-none ${toneClasses[local.tone ?? 'default']} ${local.class ?? ''}`}
    >
      {local.children}
    </kbd>
  )
}
